import { format, parse } from "date-fns";
import { ru } from "date-fns/locale";

export const parseDate = (date: string) => parse(date, 'yyyy-MM-dd', new Date());

export const formatDate = (date: string) => format(parseDate(date), 'dd MMM yyyy', { locale: ru });